import React from 'react';

import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  EmptyDataTable,
  LinearProgress,
  Card,
  CardContent,
  CardHeader,
} from '@occc/ui-design-system';
import { SiteSystemFuelPumpProduct } from '@occc/graphql';

interface IFuelProps {
  fuelItems?: SiteSystemFuelPumpProduct[];
  loading: boolean;
}

const Fuel: React.FC<IFuelProps> = ({ fuelItems, loading }) => {
  const renderContent = () => {
    if (!loading && (!fuelItems || fuelItems.length === 0)) {
      return <EmptyDataTable />;
    }

    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Outdoor Position</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Price Tier</TableCell>
            <TableCell align='right'>Unit Price</TableCell>
            <TableCell align='right'>Merchandise Code</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {fuelItems &&
            fuelItems.map((fuel, i) => (
              <TableRow key={i}>
                <TableCell>{fuel.outdoorPosition}</TableCell>
                <TableCell>{fuel.description}</TableCell>
                <TableCell>{fuel.priceTier}</TableCell>
                <TableCell align='right'>{fuel.unitPrice}</TableCell>
                <TableCell align='right'>{fuel.merchandiseCode}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    );
  };

  return (
    <Card>
      {loading && <LinearProgress />}
      <CardHeader title={<Typography variant='h6'>Fuel</Typography>} />
      <CardContent>{renderContent()}</CardContent>
    </Card>
  );
};

export default Fuel;
